export const PASSWORD_REQUIREMENTS = [
  {
    id: "length",
    label: "Minimum 12 characters",
    test: (password: string) => password.length >= 12,
  },
  {
    id: "uppercase",
    label: "At least 1 uppercase letter",
    test: (password: string) => /[A-Z]/.test(password),
  },
  {
    id: "number",
    label: "At least 1 number",
    test: (password: string) => /\d/.test(password),
  },
  {
    id: "special",
    label: "At least 1 special character (e.g. ! @ # $ %)",
    test: (password: string) => /[\W_]/.test(password),
  },
] as const;

export type PasswordRequirementCheck = {
  id: (typeof PASSWORD_REQUIREMENTS)[number]["id"];
  label: string;
  met: boolean;
};

export const getPasswordRequirementChecks = (
  password: string,
): PasswordRequirementCheck[] =>
  PASSWORD_REQUIREMENTS.map(({ id, label, test }) => ({
    id,
    label,
    met: test(password),
  }));

export const isPasswordValid = (password: string): boolean =>
  getPasswordRequirementChecks(password).every((requirement) => requirement.met);
